export const componentPathsPrefix = "";

export const componentPaths = {
  LOGIN: componentPathsPrefix + "/login",
  RECEIVING: componentPathsPrefix + "/receiving",
  RECEIVING_DETAIL: componentPathsPrefix + `/receive-detail`,
};
